<a [routerLink]="['/']">
  <h1>My Store</h1>
</a>

<button type="button" routerLink="/customers">Customers</button>
<a routerLink="/cart" class="button fancy-button"> <em class="material-icons">shopping_cart</em>Checkout </a>

<!-- 
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
-->
